import { render, staticRenderFns } from "./workshipRelation.vue?vue&type=template&id=09492d62&"
import script from "./workshipRelation.vue?vue&type=script&lang=js&"
export * from "./workshipRelation.vue?vue&type=script&lang=js&"
import style0 from "./workshipRelation.vue?vue&type=style&index=0&id=09492d62&prod&lang=scss&"
import style1 from "./workshipRelation.vue?vue&type=style&index=1&id=09492d62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports